var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.bemBlock },
    [
      _c("TheProductDetailsSizeSelector", {
        attrs: {
          product: _vm.product,
          "keep-enabled": true,
          "multiple-selection": true,
          prefix: "modal"
        },
        on: {
          "size:change": function(size, selSizes) {
            return (_vm.selectedSizes = selSizes)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          class: [_vm.bemElement("continue"), "btn", "btn--primary"],
          on: {
            click: function($event) {
              return _vm.$emit("size:confirm", _vm.selectedSizes)
            }
          }
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$msg("label.save.continue", "forms")) + "\n  "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }